import 'react-calendar/dist/Calendar.css';
import { EventCalendar } from '../../../../../components/Calendar/Calendar';
import EventsSlider from '../../../../../components/EventsSlider/EventsSlider';
import { Loader } from '../../../../../components/Loader/Loader';
import { PageLayout } from '../../../../../components/PageLayout/PageLayout';
import { useFetchEvents } from '../../../../../hooks/useFetchEvents';
import styles from './EventsSection.module.scss';

export const EventsSection = () => {
    const COUNT_OF_EVENT_ON_SLIDER = 12;
    const COUNT_OF_PAST_EVENTS = 100; // сколько прошедших подсвечивать в календаре
    // ближайшие мероприятия вместе с анонсами из новостей
    const { eventsData, isLoading } = useFetchEvents({
        page: 1,
        size: COUNT_OF_EVENT_ON_SLIDER,
        feed: 'upcoming',
    });
    // прошедшие нужны только календарю: в слайдере остаются ближайшие
    const { eventsData: pastEventsData } = useFetchEvents({
        page: 1,
        size: COUNT_OF_PAST_EVENTS,
        feed: 'archive',
    });

    // день мероприятия по Москве в виде локальной даты: календарь сравнивает
    // дни в поясе браузера, и западнее Москвы подсветка съезжала бы на день
    const toMoscowDay = (value: string) => {
        const [year, month, day] = new Date(value)
            .toLocaleDateString('en-CA', { timeZone: 'Europe/Moscow' })
            .split('-')
            .map(Number);
        return new Date(year, month - 1, day);
    };
    const feed = [...(eventsData ?? []), ...(pastEventsData ?? [])];
    const dates = feed
        .filter((data) => data.kind !== 'news')
        .map((data) => toMoscowDay(data.datetime));
    // новость с галочкой «Это мероприятие» календарь отмечает точкой
    const newsDates = feed
        .filter((data) => data.kind === 'news')
        .map((data) => toMoscowDay(data.datetime));
    return (
        <section className={styles.eventssection}>
            <PageLayout>
                <div className={styles.events}>
                    <h2 className={styles.events__header}>
                        Календарь мероприятий
                    </h2>
                    <div className={styles.events__content}>
                        <div className={styles.events__calendar}>
                            <EventCalendar
                                dates={dates}
                                newsDates={newsDates}
                            />
                        </div>
                        {isLoading ? (
                            <div className={styles.loader}>
                                <Loader />
                            </div>
                        ) : (
                            <EventsSlider eventData={eventsData} />
                        )}
                    </div>
                </div>
            </PageLayout>
        </section>
    );
};
